import React, { useEffect, useRef, useState } from "react"

import { Button, Icon, InfoOutlined } from "@cgtrader/triangle-ui/dist/src/ssr-index"
import { node } from "prop-types"

import { iconSizeMedium } from "Pods/ThreeDStudio/constants"

// Compact (<= 720px) variant: a controlled disclosure that opens the details in a
// popover. Open state is managed locally and dismissed on outside click or Escape.
function CompactCard({ children }) {
  const [isOpen, setIsOpen] = useState(false)
  const containerRef = useRef(null)

  useEffect(() => {
    if (!isOpen) {
      return undefined
    }

    const handlePointerDown = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handlePointerDown)
    document.addEventListener('keydown', handleKeyDown)

    return () => {
      document.removeEventListener('mousedown', handlePointerDown)
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [isOpen])

  const handleToggle = () => setIsOpen(prev => !prev)

  return (
    <div className="model-details-compact-card" ref={containerRef}>
      <div className="model-details-compact-card__trigger">
        <Button
          actionType="button"
          type="ghost"
          variant="only-icon"
          size="tiny"
          aria-label="Model details"
          aria-expanded={isOpen}
          aria-controls="model-details-popover"
          onClick={handleToggle}
          icon={<Icon svgComponent={InfoOutlined} color="darker" size={iconSizeMedium} notSpaced />}
        />
      </div>
      {isOpen && (
        <div className="model-details-compact-card__popover" id="model-details-popover">
          {children}
        </div>
      )}
    </div>
  )
}

CompactCard.propTypes = {
  children: node.isRequired,
}

export default CompactCard
